export enum EarlyPaymentStatus {
    /** 0 [(lsq.common.annotations.enum_display_name) */
    UNKNOWN_PAYMENT_STATUS = 'UNKNOWN_PAYMENT_STATUS',
    /** 1 [(lsq.common.annotations.enum_display_name) */
    EP_SCHEDULED = 'EP_SCHEDULED',
    /** 2 [(lsq.common.annotations.enum_display_name) */
    EP_PENDING = 'EP_PENDING',
    /** 3 [(lsq.common.annotations.enum_display_name) */
    EP_REJECTED = 'EP_REJECTED',
    /** 4 [(lsq.common.annotations.enum_display_name) */
    EP_FUNDED = 'EP_FUNDED',
    /** 5 [(lsq.common.annotations.enum_display_name) */
    EP_FUNDED_TERMS = 'EP_FUNDED_TERMS'
}
